import { assignIfExists } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { responseError } from '@/utils/errors';
import withDraft from '@/utils/draftHelper';
import { findCohort } from '../../state/shared';
import {
  findCohortVisualisation,
  resetMatchingVisualisationsOnName,
  resetMatchingVisualisationsOnValue,
  selectVisualisation,
} from './state';
import actions from '../constants';

const toggleCohortVisualisationSelected = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  selectVisualisation(item, action.chartType);
});

const fetchCohortVisualisationQuery = withDraft((draft, action) => {
  const { item, visualisation } = findCohortVisualisation(draft, action);
  selectVisualisation(item, action.chartType);
  visualisation.readStatus = states.PENDING;
});

const changeCohortVisualisationXAxis = withDraft((draft, action) => {
  const { item } = findCohortVisualisation(draft, action);
  resetMatchingVisualisationsOnName(item, action, 'xAxis');
});

const changeCohortVisualisationYAxis = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  resetMatchingVisualisationsOnName(item, action, 'yAxis');
});

const changeCohortVisualisationBins = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  resetMatchingVisualisationsOnValue(item, action.bins, 'bins');
});

const showCohortVisualisation = withDraft((draft, action) => {
  const { query, visualisation } = findCohortVisualisation(draft, action);
  assignIfExists(visualisation, {
    ...action.result,
    distinctValues: action.result.distinct_values,
    values: action.result.values,
    status: action.result.status,
    readStatus: states.SUCCESS,
    readErrors: [],
  });
  query.status = action.result.status;
});

const showCohortVisualisationError = withDraft((draft, action) => {
  const { visualisation } = findCohortVisualisation(draft, action);
  assignIfExists(visualisation, { readStatus: states.ERROR, readErrors: [responseError(action)] });
});

export default {
  [actions.CHANGE_COHORT_VISUALISATION_BINS]: changeCohortVisualisationBins,
  [actions.CHANGE_COHORT_VISUALISATION_X_AXIS]: changeCohortVisualisationXAxis,
  [actions.CHANGE_COHORT_VISUALISATION_Y_AXIS]: changeCohortVisualisationYAxis,
  [actions.FETCH_COHORT_VISUALISATION_BAR_QUERY]: fetchCohortVisualisationQuery,
  [actions.FETCH_COHORT_VISUALISATION_BOX_PLOT_QUERY]: fetchCohortVisualisationQuery,
  [actions.FETCH_COHORT_VISUALISATION_HISTOGRAM_QUERY]: fetchCohortVisualisationQuery,
  [actions.FETCH_COHORT_VISUALISATION_STACKED_BAR_QUERY]: fetchCohortVisualisationQuery,
  [actions.SHOW_COHORT_VISUALISATION]: showCohortVisualisation,
  [actions.SHOW_COHORT_VISUALISATION_ERROR]: showCohortVisualisationError,
  [actions.TOGGLE_COHORT_VISUALISATION_SELECTED]: toggleCohortVisualisationSelected,
};
